"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledClearIndicatorContainer = exports.PencilDropdownIndicator = exports.DefaultDropdownIndicator = exports.CreatableSelectWrapper = exports.AsyncSelectWrapper = exports.AsyncCreatableSelectWrapper = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = require("react-select");
var _async = _interopRequireDefault(require("react-select/async"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check16"));
var _HBDropdown = require("./HBDropdown.styles");
var _HBDropdownNoOptions = _interopRequireDefault(require("./HBDropdownNoOptions"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _lodash = require("lodash");
var _XCircleFilled = _interopRequireDefault(require("@honeybook/icons/dist/icons/XCircleFilled16"));
var _excluded = ["children"],
  _excluded2 = ["autoFocus", "backspaceRemovesValue", "blurInputOnSelect", "cacheOptions", "checkIconColor", "className", "closeMenuOnScroll", "closeMenuOnSelect", "customIconOnControl", "customMenuComponent", "customMenuListComponent", "customOptionComponent", "customSingleValueComponent", "customStyles", "customValueComponent", "customNoOptionsComponent", "defaultMenuIsOpen", "shouldSelectOnCreate", "defaultOptions", "disabled", "dropdownIndicatorColor", "dropdownTheme", "error", "filterOption", "focusStyles", "formatCreateLabel", "formatOptionLabel", "id", "testIdName", "testId", "inputProps", "inputValue", "isClearable", "isCreatable", "isAsync", "isOptionDisabled", "isSearchable", "loadOptions", "maxMenuHeight", "minMenuHeight", "menuIsOpen", "menuPlacement", "menuAlign", "menuShouldScrollIntoView", "menuPortalTarget", "minWidth", "noIndicator", "noOptionsButtonText", "noOptionsExplanationText", "noOptionsColor", "noOptionsMessage", "onBlur", "onChange", "onCreateOption", "onFocus", "onMenuOpen", "onMenuClose", "openMenuOnFocus", "options", "outlineColor", "placeholder", "scope", "size", "stylesToInherit", "usePencilIndicator", "value", "isValidNewOption", "dropdownRef"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DefaultDropdownIndicator = exports.DefaultDropdownIndicator = function DefaultDropdownIndicator() {
  var dropdownIndicatorColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors["default"].neutral900;
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(_HBDropdown.ArrowIcon, {
      color: props.isDisabled ? _colors["default"].neutral400 : dropdownIndicatorColor
    }));
  };
};
var PencilDropdownIndicator = exports.PencilDropdownIndicator = function PencilDropdownIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(_HBDropdown.PencilIcon, {
    color: _colors["default"].neutral400,
    hoverColor: _colors["default"].neutral700
  }));
};
var createOptionComponent = function createOptionComponent(CustomOptionComponent, checkIconColor, testId) {
  return function (props) {
    var children = props.children;
    var _props = addTestIdToInnerProps(props, testId, 'option');
    if (!CustomOptionComponent) {
      return /*#__PURE__*/_react["default"].createElement(DefaultOption, (0, _extends2["default"])({}, _props, {
        checkIconColor: checkIconColor
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, _props, /*#__PURE__*/_react["default"].createElement(CustomOptionComponent, (0, _extends2["default"])({}, props, {
      index: props.options.indexOf(props.data)
    }), children));
  };
};
var DefaultOption = function DefaultOption(props) {
  var children = props.children,
    isSelected = props.isSelected,
    checkIconColor = props.checkIconColor;
  var _props$data = props.data,
    icon = _props$data.icon,
    subLabel = _props$data.subLabel,
    isSubLabelGreyed = _props$data.isSubLabelGreyed,
    _title = _props$data.title;
  var Icon = function Icon(iconProps) {
    return icon(iconProps);
  };
  var title = typeof children === 'string' ? children : _title;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react["default"].createElement(_HBDropdown.OptionWrapper, {
    isSubLabel: !!subLabel
  }, icon && /*#__PURE__*/_react["default"].createElement(_HBDropdown.IconSpan, null, /*#__PURE__*/_react["default"].createElement(Icon, {
    color: _colors["default"].neutral900
  })), /*#__PURE__*/_react["default"].createElement(_HBDropdown.LabelSpan, {
    title: title,
    hasIcon: icon
  }, children), subLabel && /*#__PURE__*/_react["default"].createElement(_HBDropdown.SubLabelSpan, {
    title: subLabel,
    $isSubLabelGreyed: isSubLabelGreyed
  }, subLabel)), isSelected && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    color: checkIconColor
  }));
};
var createSingleValueComponent = function createSingleValueComponent(CustomSingleValueComponent) {
  return function (props) {
    var children = props.children;
    if (!CustomSingleValueComponent) {
      return /*#__PURE__*/_react["default"].createElement(DefaultSingleValue, props);
    }
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, props, /*#__PURE__*/_react["default"].createElement(CustomSingleValueComponent, props, children));
  };
};
var DefaultSingleValue = function DefaultSingleValue(props) {
  var _props$data2 = props.data,
    icon = _props$data2.icon,
    label = _props$data2.label;
  var Icon = function Icon(iconProps) {
    return icon(iconProps);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon && /*#__PURE__*/_react["default"].createElement(_HBDropdown.IconSpan, null, /*#__PURE__*/_react["default"].createElement(Icon, {
    color: _colors["default"].neutral900
  })), /*#__PURE__*/_react["default"].createElement(_HBDropdown.LabelSpan, {
    hasIcon: icon
  }, label));
};
var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledClearIndicatorContainer, props, /*#__PURE__*/_react["default"].createElement(_XCircleFilled["default"], {
    color: _colors["default"].neutral600
  }));
};
var createComponent = function createComponent(name, CustomComponent, testId, CustomIconOnControl) {
  var Component = _reactSelect.components[name];
  var customIconWithContainer = CustomIconOnControl && /*#__PURE__*/_react["default"].createElement(_HBDropdown.CustomIconContainer, null, /*#__PURE__*/_react["default"].createElement(CustomIconOnControl, null));
  return function (_ref) {
    var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Component, addTestIdToInnerProps(props, testId, name), CustomComponent ? /*#__PURE__*/_react["default"].createElement(CustomComponent, props, customIconWithContainer, children) : CustomIconOnControl ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customIconWithContainer, " ", children) : children);
  };
};
var addTestIdToInnerProps = function addTestIdToInnerProps(props, testId, componentName) {
  if (!testId || !componentName) {
    return props;
  }
  // <Input/> doesn't have innerProps
  var target = props.innerProps || props;
  var testIdProp = {
    'data-testid': "".concat(testId, "-").concat((0, _lodash.kebabCase)(componentName))
  };
  Object.assign(target, testIdProp);
  return props;
};
var HBDropdown = function HBDropdown(_ref2) {
  var autoFocus = _ref2.autoFocus,
    backspaceRemovesValue = _ref2.backspaceRemovesValue,
    blurInputOnSelect = _ref2.blurInputOnSelect,
    cacheOptions = _ref2.cacheOptions,
    _ref2$checkIconColor = _ref2.checkIconColor,
    checkIconColor = _ref2$checkIconColor === void 0 ? _colors["default"].blue20 : _ref2$checkIconColor,
    className = _ref2.className,
    closeMenuOnScroll = _ref2.closeMenuOnScroll,
    closeMenuOnSelect = _ref2.closeMenuOnSelect,
    customIconOnControl = _ref2.customIconOnControl,
    customMenuComponent = _ref2.customMenuComponent,
    customMenuListComponent = _ref2.customMenuListComponent,
    customOptionComponent = _ref2.customOptionComponent,
    customSingleValueComponent = _ref2.customSingleValueComponent,
    customStyles = _ref2.customStyles,
    customValueComponent = _ref2.customValueComponent,
    customNoOptionsComponent = _ref2.customNoOptionsComponent,
    defaultMenuIsOpen = _ref2.defaultMenuIsOpen,
    shouldSelectOnCreate = _ref2.shouldSelectOnCreate,
    defaultOptions = _ref2.defaultOptions,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    dropdownIndicatorColor = _ref2.dropdownIndicatorColor,
    _ref2$dropdownTheme = _ref2.dropdownTheme,
    dropdownTheme = _ref2$dropdownTheme === void 0 ? 'default' : _ref2$dropdownTheme,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error,
    filterOption = _ref2.filterOption,
    focusStyles = _ref2.focusStyles,
    formatCreateLabel = _ref2.formatCreateLabel,
    formatOptionLabel = _ref2.formatOptionLabel,
    id = _ref2.id,
    testIdName = _ref2.testIdName,
    testId = _ref2.testId,
    inputProps = _ref2.inputProps,
    inputValue = _ref2.inputValue,
    _ref2$isClearable = _ref2.isClearable,
    isClearable = _ref2$isClearable === void 0 ? false : _ref2$isClearable,
    _ref2$isCreatable = _ref2.isCreatable,
    isCreatable = _ref2$isCreatable === void 0 ? false : _ref2$isCreatable,
    _ref2$isAsync = _ref2.isAsync,
    isAsync = _ref2$isAsync === void 0 ? false : _ref2$isAsync,
    isOptionDisabled = _ref2.isOptionDisabled,
    _ref2$isSearchable = _ref2.isSearchable,
    isSearchable = _ref2$isSearchable === void 0 ? false : _ref2$isSearchable,
    loadOptions = _ref2.loadOptions,
    maxMenuHeight = _ref2.maxMenuHeight,
    minMenuHeight = _ref2.minMenuHeight,
    menuIsOpen = _ref2.menuIsOpen,
    _ref2$menuPlacement = _ref2.menuPlacement,
    menuPlacement = _ref2$menuPlacement === void 0 ? 'bottom' : _ref2$menuPlacement,
    _ref2$menuAlign = _ref2.menuAlign,
    menuAlign = _ref2$menuAlign === void 0 ? 'start' : _ref2$menuAlign,
    menuShouldScrollIntoView = _ref2.menuShouldScrollIntoView,
    menuPortalTarget = _ref2.menuPortalTarget,
    minWidth = _ref2.minWidth,
    _ref2$noIndicator = _ref2.noIndicator,
    noIndicator = _ref2$noIndicator === void 0 ? false : _ref2$noIndicator,
    noOptionsButtonText = _ref2.noOptionsButtonText,
    noOptionsExplanationText = _ref2.noOptionsExplanationText,
    noOptionsColor = _ref2.noOptionsColor,
    noOptionsMessage = _ref2.noOptionsMessage,
    onBlur = _ref2.onBlur,
    onChange = _ref2.onChange,
    onCreateOption = _ref2.onCreateOption,
    onFocus = _ref2.onFocus,
    onMenuOpen = _ref2.onMenuOpen,
    onMenuClose = _ref2.onMenuClose,
    openMenuOnFocus = _ref2.openMenuOnFocus,
    options = _ref2.options,
    _ref2$outlineColor = _ref2.outlineColor,
    outlineColor = _ref2$outlineColor === void 0 ? _colors["default"].neutral200 : _ref2$outlineColor,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? 'Select an option' : _ref2$placeholder,
    scope = _ref2.scope,
    size = _ref2.size,
    _ref2$stylesToInherit = _ref2.stylesToInherit,
    stylesToInherit = _ref2$stylesToInherit === void 0 ? [] : _ref2$stylesToInherit,
    _ref2$usePencilIndica = _ref2.usePencilIndicator,
    usePencilIndicator = _ref2$usePencilIndica === void 0 ? false : _ref2$usePencilIndica,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? null : _ref2$value,
    isValidNewOption = _ref2.isValidNewOption,
    dropdownRef = _ref2.dropdownRef,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var styles = (0, _HBDropdown.getCustomStyles)({
    size: size,
    scope: scope,
    dropdownTheme: dropdownTheme,
    ignoreStylesOf: {
      option: !!customOptionComponent && !stylesToInherit.includes('option'),
      SingleValue: !!customSingleValueComponent && !stylesToInherit.includes('SingleValue')
    },
    customStyles: customStyles,
    focusStyles: focusStyles,
    error: error,
    outlineColor: outlineColor,
    withIcon: !!customIconOnControl,
    menuAlign: menuAlign
  });
  var selected = null;
  if (props.isMulti) {
    selected = value;
  } else {
    options.forEach(function (item) {
      if (item.options) {
        item.options.forEach(function (option) {
          if (option.value === value) {
            selected = option;
          }
        });
      }
      if (item.value === value && !item.isFakeOption) {
        selected = item;
      }
    });
  }
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'dropdown',
    componentName: 'HBDropdown'
  });
  var handleAsyncChange = function handleAsyncChange(item) {
    if (item && item.isFakeOption && item.handleFakeOptionClick) {
      return item.handleFakeOptionClick();
    }
    return onChange(item);
  };
  var handleChange = function handleChange(item) {
    if (props.isMulti) {
      //@ts-ignore
      return onChange(item);
    }
    //@ts-ignore
    if (item && item.isFakeOption && item.handleFakeOptionClick) {
      //@ts-ignore
      return item.handleFakeOptionClick();
    }
    //@ts-ignore
    return onChange(item === null || item === void 0 ? void 0 : item.value);
  };
  var DropdownIndicator = (0, _react.useMemo)(function () {
    if (noIndicator) {
      return null;
    }
    if (usePencilIndicator) {
      return PencilDropdownIndicator;
    }
    return DefaultDropdownIndicator(dropdownIndicatorColor);
  }, [dropdownIndicatorColor, noIndicator, usePencilIndicator]);
  var Option = (0, _react.useMemo)(function () {
    return createOptionComponent(customOptionComponent, checkIconColor, finalTestId);
  }, [checkIconColor, customOptionComponent, finalTestId]);
  var SingleValue = (0, _react.useMemo)(function () {
    return createSingleValueComponent(customSingleValueComponent);
  }, [customSingleValueComponent]);
  var Menu = (0, _react.useMemo)(function () {
    return createComponent('Menu', customMenuComponent);
  }, [customMenuComponent]);
  var MenuList = (0, _react.useMemo)(function () {
    return createComponent('MenuList', customMenuListComponent);
  }, [customMenuListComponent]);
  var ValueContainer = (0, _react.useMemo)(function () {
    return createComponent('ValueContainer', customValueComponent);
  }, [customValueComponent]);
  var NoOptionsMessage = (0, _react.useMemo)(function () {
    return createComponent('NoOptionsMessage', customNoOptionsComponent, noOptionsColor);
  }, [customNoOptionsComponent, noOptionsColor]);
  var NoOptionsPanel = (0, _react.useMemo)(function () {
    return formatCreateLabel || function (searchValue) {
      return /*#__PURE__*/_react["default"].createElement(_HBDropdownNoOptions["default"], {
        value: searchValue,
        noOptionsButtonText: noOptionsButtonText,
        dropdownNoOptionsExplanation: noOptionsExplanationText,
        color: noOptionsColor
      });
    };
  }, [formatCreateLabel, noOptionsButtonText, noOptionsColor, noOptionsExplanationText]);
  var Control = (0, _react.useMemo)(function () {
    return createComponent('Control', null, finalTestId, customIconOnControl);
  }, [finalTestId, customIconOnControl]);
  var Input = (0, _react.useMemo)(function () {
    return createComponent('Input', null, finalTestId);
  }, [finalTestId]);
  var getCreateOptionResult = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(newOption) {
      var result;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (onCreateOption) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", Promise.resolve());
          case 2:
            result = onCreateOption(newOption);
            if (!(result instanceof Promise)) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return result;
          case 6:
            return _context.abrupt("return", Promise.resolve());
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCreateOptionResult(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleOptionCreation = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(newOption) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!onCreateOption) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return getCreateOptionResult(newOption);
          case 3:
            if (shouldSelectOnCreate) {
              if (isAsync) {
                handleAsyncChange({
                  value: newOption,
                  label: newOption
                });
              } else {
                onChange(newOption);
              }
            }
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleOptionCreation(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleBlur = function handleBlur(e) {
    onBlur === null || onBlur === void 0 || onBlur(e);
    // this is to cause the option to be created and selected when the user clicks outside the dropdown
    var newOption = e.target.value;
    if (newOption) {
      handleOptionCreation(newOption);
    }
  };
  function getDefaultInputValue() {
    return (0, _typeof2["default"])(value) === 'object' && !Array.isArray(value) ? value === null || value === void 0 ? void 0 : value.label : value;
  }
  var commonProps = {
    id: id,
    name: id,
    menuPortalTarget: menuPortalTarget,
    minWidth: minWidth,
    options: options,
    styles: styles,
    isMulti: props.isMulti,
    isSearchable: isSearchable,
    isDisabled: disabled,
    placeholder: placeholder,
    menuPlacement: menuPlacement,
    menuShouldScrollIntoView: menuShouldScrollIntoView,
    maxMenuHeight: maxMenuHeight,
    minMenuHeight: minMenuHeight,
    onMenuOpen: onMenuOpen,
    onMenuClose: onMenuClose,
    className: className,
    classNamePrefix: 'hb-dropdown',
    components: {
      Control: Control,
      Input: Input,
      Option: Option,
      DropdownIndicator: DropdownIndicator,
      SingleValue: SingleValue,
      Menu: Menu,
      MenuList: MenuList,
      ValueContainer: ValueContainer,
      NoOptionsMessage: NoOptionsMessage,
      ClearIndicator: ClearIndicator
    },
    onBlur: handleBlur,
    onFocus: onFocus,
    menuIsOpen: menuIsOpen,
    defaultMenuIsOpen: defaultMenuIsOpen,
    closeMenuOnScroll: closeMenuOnScroll,
    isOptionDisabled: isOptionDisabled,
    onCreateOption: handleOptionCreation,
    isClearable: isClearable,
    isValidNewOption: isValidNewOption || function (inputValueText) {
      return isCreatable && inputValueText;
    },
    closeMenuOnSelect: closeMenuOnSelect,
    inputValue: inputValue,
    blurInputOnSelect: blurInputOnSelect,
    formatCreateLabel: NoOptionsPanel,
    formatOptionLabel: formatOptionLabel,
    noOptionsMessage: noOptionsMessage,
    filterOption: filterOption,
    autoFocus: autoFocus,
    openMenuOnFocus: openMenuOnFocus,
    backspaceRemovesValue: backspaceRemovesValue,
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      autoComplete: 'nope'
    }),
    ref: dropdownRef,
    hideSelectedOptions: props.isMulti && props.hideSelectedOptions
  };
  if (isCreatable && isAsync) {
    return /*#__PURE__*/_react["default"].createElement(AsyncCreatableSelectWrapper, (0, _extends2["default"])({}, commonProps, {
      value: value,
      options: options,
      defaultOptions: defaultOptions,
      loadOptions: loadOptions,
      cacheOptions: cacheOptions,
      onChange: handleAsyncChange
    }));
  }
  return isAsync ? /*#__PURE__*/_react["default"].createElement(AsyncSelectWrapper, (0, _extends2["default"])({}, commonProps, {
    value: value,
    defaultInputValue: getDefaultInputValue(),
    defaultOptions: defaultOptions,
    loadOptions: loadOptions,
    cacheOptions: cacheOptions,
    onChange: handleAsyncChange
  })) : /*#__PURE__*/_react["default"].createElement(CreatableSelectWrapper, (0, _extends2["default"])({}, commonProps, {
    value: selected,
    options: options,
    onChange: handleChange
  }));
};
var styles = (0, _styledComponents.css)(["min-width:", ";input{margin:0 !important;}"], function (props) {
  return props.minWidth ? "".concat(props.minWidth, " !important") : null;
});
var StyledClearIndicatorContainer = exports.StyledClearIndicatorContainer = (0, _styledComponents["default"])(_reactSelect.components.ClearIndicator).withConfig({
  displayName: "HBDropdown__StyledClearIndicatorContainer",
  componentId: "sc-12g4knu-0"
})(["i{display:flex;svg *{transition:fill 100ms;}}&:hover i svg *{fill:", ";}"], _colors["default"].neutral900);
var CreatableSelectWrapper = exports.CreatableSelectWrapper = (0, _styledComponents["default"])(_creatable["default"]).withConfig({
  displayName: "HBDropdown__CreatableSelectWrapper",
  componentId: "sc-12g4knu-1"
})(["", ""], styles);
var AsyncSelectWrapper = exports.AsyncSelectWrapper = (0, _styledComponents["default"])(_async["default"]).withConfig({
  displayName: "HBDropdown__AsyncSelectWrapper",
  componentId: "sc-12g4knu-2"
})(["", ""], styles);
var AsyncCreatableSelectWrapper = exports.AsyncCreatableSelectWrapper = (0, _styledComponents["default"])(_asyncCreatable["default"]).withConfig({
  displayName: "HBDropdown__AsyncCreatableSelectWrapper",
  componentId: "sc-12g4knu-3"
})(["", ""], styles);
var _default = exports["default"] = HBDropdown;
//# sourceMappingURL=HBDropdown.js.map